'use strict'

import React      from 'react'
import $          from 'jquery'
import API        from '../services/api'
import ButtonPage from '../assets/button-page'

export default class ProcedureType extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      treatmentOptions: []
    }
  }

  componentDidMount () {
    let api = new API()
    api.getTreatmentOptions().then((result) => {
      this.setState({
        treatmentOptions: result
      })
    })
  }

  knowWhatsNeeded (e) {
    window.ga('send', 'event', {
      eventCategory: 'Dental Question',
      eventAction: 'Click',
      eventLabel: 'Procedure'
    })

    let values = []

    $(e.target).closest('.button-page').find('input:checked').each((i, val) => {
      values.push($(val).attr('data-option'))
    })

    this.props.onChange('know-whats-needed', {
      displayName: 'Treatment Interested',
      value: values,
      pageRef: '',
      order: 6,
      displayInSummary: true
    })
  }

  render () {
    const { treatmentOptions } = this.state
    const { summary } = this.props

    let activeValue = (summary['know-whats-needed']) ? summary['know-whats-needed'].value : ''

    return (
      <div className="procedure-type">
        <h2 className="header outline">Procedure Type</h2>
        <h2 className="summary-question">What type of procedure do you need to get done?</h2>
        <ButtonPage
          reference="name"
          multiple="true"
          buttons={treatmentOptions}
          onClick={this.knowWhatsNeeded.bind(this)}
          activeValue={activeValue} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/procedure-type.js